/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {declineMicroAuthCheck} from '../api'

export const useMutationDeclineMicroAuthCheck = createReactQueryMutationHook('declineMicroAuthCheck', declineMicroAuthCheck)
